(function () {

    var DETAIL_VIEW_URL = '/story/subscription-guide/';
    var LIST_AJAX_URL = '/story/subscription-guideList.lgajax';

    var listTemplate = '' +
        '{{#each (item, index) in list}}' +
        '    <li>' +
        '        <a href="{{item.detailHref}}">' +
        '            <div class="thumb">' +
        '                <img src="{{item.thumbnailUrl}}" alt="" class="no-img">' +
        '            </div>' +
        '            <p class="tit">{{#raw item.displayTitle}}</p>' +
        '        </a>' +
        '    </li>' +
        '{{/each}}';

    var storySubscriptionGuideList = {
        init: function () {
            var self = this;
            var $paginationContainer = $('section.KRP0026[data-guide-type="subscription"] div.story-list-wrap .pagination');

            $paginationContainer.css('pointer-events', 'none');

            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();

                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, false, true);

                $paginationContainer.css('pointer-events', 'auto');
            });
        },

        setting: function () {
            var self = this;
            var $contents = $('section.KRP0026[data-guide-type="subscription"] div.story-list-wrap');
            self.$pagination = $contents.find('div.pagination').vcPagination();
            self.$itemList = $contents.find('ul.story-list-box');
        },

        bindEvents: function () {
            var self = this;

            self.$pagination.on('page_click', function (e, page) {
                var urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', page);
                self.requestData(urlParams);
            });

            $(window).on('popstate', function () {
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, true);
            });
        },

        requestData: function (urlParams, skipHistoryUpdate, isInitial) {
            var self = this;
            var $itemList = self.$itemList;

            var params = {};
            urlParams.forEach(function (value, key) {
                params[key] = value;
            });

            if (!skipHistoryUpdate) {
                var queryString = urlParams.toString();
                if (queryString !== '') {
                    history.pushState(null, '', window.location.pathname + '?' + queryString);
                } else {
                    history.pushState(null, '', window.location.pathname);
                }
            }

            lgkorUI.requestAjaxData(LIST_AJAX_URL, params, function (result) {
                if (!result || result.status !== 'success') {
                    $itemList.hide();
                    self.$pagination.hide();
                    return;
                }

                var listData = result.data instanceof Array ? result.data : [];
                if (listData.length > 0) {
                    self.$pagination.show();
                    var querySuffix = window.location.search || '';
                    listData.forEach(function (item) {
                        item.detailHref = [DETAIL_VIEW_URL, item.guideId, querySuffix].join('');
                    });
                    $itemList.html(vcui.template(listTemplate, { list: listData }));
                    $itemList.show();
                } else {
                    $itemList.hide();
                    self.$pagination.hide();
                }

                var pageInfo = result.param && result.param.pagination ? result.param.pagination : {};
                var pageNo = pageInfo.page != null ? parseInt(pageInfo.page, 10) : 1;
                if (isNaN(pageNo) || pageNo < 1) {
                    pageNo = 1;
                }
                var totalPage = pageInfo.totalCount != null ? pageInfo.totalCount : 1;

                self.$pagination.vcPagination('setPageInfo', {
                    page: pageNo,
                    totalCount: totalPage
                });

                if (!isInitial) {
                    $itemList.find('li:first a').focus();
                }
            }, 'GET', 'json', true);
        }
    };

    $(document).ready(function () {
        if ($('section.KRP0026[data-guide-type="subscription"] div.story-list-wrap ul.story-list-box').length) {
            storySubscriptionGuideList.init();
        }
    });
})();
